export default __webpack_public_path__ + "static/media/iceCream_img.73c74e08.jpg";